import { Globals } from "../CoreApp/Globals";
import { QTextHeight } from "../CoreApp/QTextHeight";

export function CacheHeight(fontString, txtHeight, noHangHeight) {
  if (Globals._textHeightCache == null) Globals._textHeightCache = new Map();

  var t = new QTextHeight(fontString, txtHeight, noHangHeight);
  Globals._textHeightCache.set(fontString, t);

  return t;
}
